import React, {useState} from 'react';
import Button from "../UI/Button";
import TrialStep from "./TrialStep";
import PurchaseStep from "./PurchaseStep";
import {useRegistrationSteps} from "../../utilities/context/registration-steps/registration-steps-context";
import CompletedPurchaseMessage from "./CompletedPurchaseMessage";

const Step3 = ({trial}) => {

    const {selectedSubscription} = useRegistrationSteps();

    const [completed, setCompleted] = useState(false);

    return (
        <div>
            {completed
                ? <CompletedPurchaseMessage/>
                : <div>
                    {selectedSubscription.trial ?
                        <TrialStep subscription={selectedSubscription} onSuccess={() => setCompleted(true)}/>
                        :
                        <PurchaseStep subscription={selectedSubscription} onSuccess={() => setCompleted(true)}/>
                    }
                </div>
            }
        </div>
    );
};

export default Step3;